/**
 * A single wordmark pinned to the bottom of the viewport, behind everything.
 *
 * Replaces the earlier tiled rows: one mark reads as a watermark the page sits
 * on, where repeated rows read as a pattern competing with the content. It is
 * fixed rather than scrolled, so it stays put as the page moves past it.
 *
 * Treatment is the same set of utilities as the footer wordmark, so the fade,
 * the clip-to-text and the weight match by construction rather than being
 * re-specified.
 */
export function MonoBackground() {
  return (
    <div className="mono-bg" aria-hidden="true">
      <div className="dark:from-orange-75/[0.035] dark:to-orange-75/0 mono-bg__row pointer-events-none overflow-hidden bg-linear-to-b from-orange-950/10 from-25% to-orange-950/0 bg-clip-text leading-none font-black text-transparent select-none">
        mono
      </div>
    </div>
  );
}
